/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AvatarMigrationResult
 */
export interface AvatarMigrationResult {
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'afterBytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'beforeBytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'heightAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'heightBefore'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarMigrationResult
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AvatarMigrationResult
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'savedBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof AvatarMigrationResult
     */
    'status': AvatarMigrationResultStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'userAccountId': number;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'widthAfter'?: number;
    /**
     * 
     * @type {number}
     * @memberof AvatarMigrationResult
     */
    'widthBefore'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AvatarMigrationResultStatusEnum {
    Ok = 'OK',
    Warn = 'WARN',
    Error = 'ERROR'
}


